import { useFrameDetector } from '../hooks/frame-detector'
import { useBrand } from '../hooks/brand'
import { useChat } from '../hooks/chat'
import { useMemo } from 'react'
import { useLocale } from '../hooks/locale'
import ChatManager from './chat-manager'

export default function ChatLoader (): JSX.Element {
  const locale = useLocale()
  const frame = useFrameDetector()
  const brand = useBrand()

  const enabled = useMemo(() => brand === 'boatbiketours' && !frame, [brand, frame])

  const settings = useMemo(() => ({ enabled, locale }), [enabled, locale])
  useChat(settings)
  return <ChatManager />
}
